import { Mail, Phone } from "lucide-react";
import { Col, Container, Row } from "react-bootstrap";
import { Utils } from "../../common/Utils";

const Footer = () => {
  return (
    <footer className="App-footer">
      <Container>

        <Row>
          <Col md={6}>
          <div className="mt-4 mb-3">
            <a href="https://www.orderq.co.za"><img src="/logo-white.png" alt="OrderQ Logo" style={{ height: '3rem', marginBottom: '1rem' }} /></a>
            <p style={{ color: '#cbd5e0', marginBottom: '1.5rem', lineHeight: '1.6' }}>
              Helping food businesses eliminate queues and serve more customers through smart mobile ordering solutions.
            </p>
            </div>
          </Col>

          <Col md={3}>
            <h4 className="mt-4 mb-3">Store</h4>
            <ul className="list-unstyled">
              <li><a href={Utils.GetUrl("/orders")} className="text-decoration-none text-light">Orders</a></li>
              {/* <li><a href={Utils.GetUrl("/orders")} className="text-decoration-none text-light">Orders</a></li>               */}
            </ul>
          </Col>

          <Col md={3}>
            <h4 className="mt-4 mb-3">Contact</h4>
            <ul className="list-unstyled">
              <li className="d-flex align-items-center">
                <Phone size={16} className="me-2" />
                <a href="tel:+27828531162" className="text-decoration-none text-light">+27 (0) 82-853-1162</a>
              </li>
              <li className="d-flex align-items-center mt-2">
                <img src="/whatsapp-white.png" alt="WhatsApp" style={{ height: '20px', width: '20px' }} className="me-2" />
                <a href="whatsapp://send?phone=+27828531162" className="text-decoration-none text-light">+27 (0) 82-853-1162</a>
              </li>
              <li className="d-flex align-items-center mt-2">
                <Mail size={16} className="me-2" />
                <a href="mailto:hello@orderq.co.za" className="text-decoration-none text-light">hello@orderq.co.za</a>
              </li>
              <li className="mt-2">
                <a href="https://www.orderq.co.za/support" className="text-decoration-none text-light">Support Center</a>
              </li>
            </ul>
          </Col>
        </Row>


        <hr style={{ borderColor: '#2d3748' }} />
        <div className="text-center mt-4" style={{ color: '#a0aec0' }}>
          <p>&copy; 2025 OrderQ. All rights reserved. Built to eliminate queues and boost your business.</p>
        </div>

      </Container>
    </footer>
  );
};

export default Footer;